import { combineComponents } from '@/utils/combineComponents';
import { MemberContextProvider } from '@/contexts/MemberContext';
import { RemindersProvider } from '@/components/RemindersContext';
import { DialogContextProvider } from '@/contexts/DialogContext';

const components = [DialogContextProvider, MemberContextProvider, RemindersProvider];

export const InternalProviders = combineComponents(...components);
